// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".options-drawer[data-v-b77035fa]{border-radius:12px 12px 0 0;padding-left:env(safe-area-inset-left);padding-right:env(safe-area-inset-right);@media (min-width:600px){border-radius:0}}.credit-card-button[data-v-b77035fa]{width:100%;height:48px}.shared-field[data-v-b77035fa]{width:50%!important;max-width:50%!important}.credit-card-add[data-v-b77035fa],.credit-card-editor[data-v-b77035fa]{width:100%!important}.credit-card-fieldset[data-v-b77035fa]{height:70px}", ""]);
// Exports
module.exports = exports;
